import { ProfileActions } from './profile.actions';

export const initialProfileState: IUserProfile = { name: '', email: ''};

export function profileReducer (state: IUserProfile  = initialProfileState, action: any) {
  const object: any = Object;
  switch (action.type) {
    case ProfileActions.UPDATE:
      return object.assign({}, action.payload);
    default:
      return state;
  }
};
